// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"71":"02c46abe","454":"7ef9e38a"}[chunkId] + ".css";
};